import { useStore } from '../lib/hooks';
import type { MeterLevels } from '../lib/audio';
import type { Store } from '../lib/store';

export function Meter({ store, label, level }: { store: Store<MeterLevels>; label: string; level: keyof MeterLevels }) {
  const meters = useStore(store);
  const value = meters[level];
  return (
    <div className="meter" title={`${label}: ${Math.round(value * 100)}%`}>
      <span className="meter__label">{label}</span>
      <span className="meter__track">
        <span
          className="meter__fill"
          style={{ transform: `scaleX(${Math.min(1, Math.max(0, value * 1.35))})` }}
        />
      </span>
    </div>
  );
}
